export const getImage = (path: string) => {
  return process.env.PUBLIC_URL + path;
};
